module.exports = __webpack_public_path__ + "media/mail/fa-facebook-b14ab26f.png";